<template>
  <div>
    <merus-data-table
      :headers="headers"
      :items="items"
      :default-multi-sort="defaultMultiSort"
      dense
      class="elevation-7"
      locale="pt"
      :loading="loading"
      :loading-text="$t('system.messages.loading')"
      style="border-radius: 10px"
      virtualize-rows
      @update:displayedItems="$emit('update:displayedItems', $event)"
    >
      <template v-slot:toolbar>
        <CadastroToolbar
          :title="$t('nav.reports.notifications')"
          :token="token"
          :items="exportItems"
          csv-title="notificacoes"
          :csv-headers="csvHeaders"
          :pdf-title="$t('nav.reports.notifications')"
          :pdf-headers="csvHeaders"
          pdf-filename="notificacoes"
          hide-search
        >
          <template v-slot:add>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="primary"
                  dark
                  small
                  class="mb-2 mr-2"
                  fab
                  @click="$emit('tratar-todas')"
                >
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.treatAll') }}</span>
            </v-tooltip>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          :disabled="item.reset == 0 ? false : true"
          class="mr-2"
          color="blue"
          @click="$emit('tratar', item)"
        >mdi-checkbox-marked-circle</v-icon>
        <v-icon
          class="mr-2"
          color="green"
          :disabled="!item.lat || !item.lng"
          @click="$emit('mostrar-mapa', item)"
        >mdi-map-marker</v-icon>
      </template>
      <template v-slot:item.detalhe="{ item }">
        <span class="notificacoes-dia-detalhe">{{ item.detalhe }}</span>
      </template>
    </merus-data-table>
  </div>
</template>

<script>
import MerusDataTable from "@/components/Tables/MerusDataTable.vue";
import CadastroToolbar from "@/components/Toolbars/CadastroToolbar.vue";

export default {
  name: "NotificacoesDiaTable",
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  props: {
    headers: {
      type: Array,
      default() {
        return [];
      },
    },
    csvHeaders: {
      type: Array,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    exportItems: {
      type: Array,
      default() {
        return [];
      },
    },
    defaultMultiSort: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    token: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.notificacoes-dia-detalhe {
  white-space: pre-line;
  font-size: 12px;
  line-height: 1.35;
}
</style>
